module.exports = __webpack_public_path__ + "e17c44b2d6689463899b823f3201f837.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/red-doge.svg
// module id = 365
// module chunks = 0